import request from '#api/axios';
import { useMutation, useQuery } from '@tanstack/react-query';
import { ThreadType } from 'src/r_page/Trainer-Community';

export const getUserCommunity = async (limit?: number) => {
  const res = await request<ThreadType[]>({
    method: 'get',
    url: `/consumer/exercise/questions`,
    params: {
      limit
    }
  });
  return res.data;
};

export const useGetUserCommunityQuery = (isQnaList: boolean, limit?: number) =>
  useQuery(
    ['get-information-community-threads'],
    () => getUserCommunity(limit),
    {
      enabled: !isQnaList
    }
  );

export const getQnaCommunity = async () => {
  const res = await request<ThreadType[]>({
    method: 'get',
    url: `/consumer/qna/questions`
  });
  return res.data;
};

export const useGetQnaCommunityQuery = (isQnaList: boolean) =>
  useQuery(['get-qna-community-threads'], getQnaCommunity, {
    enabled: isQnaList
  });

export const getUserCommunityBookmarks = async () => {
  const res = await request<ThreadType[]>({
    method: 'get',
    url: '/consumer/exercise/bookmarks'
  });
  return res.data;
};

export const useGetUserCommunityBookmarksQuery = () =>
  useQuery(['consumer-bookmarks'], getUserCommunityBookmarks);

export const getUserCommunityDetail = async (questionId: string) => {
  const res = await request<ThreadType>({
    method: 'get',
    url: `/consumer/exercise/questions/${questionId}`
  });
  return res.data;
};

export const useGetUserCommunityDetailQuery = (questionId: string) =>
  useQuery(['consumer-detail'], () => getUserCommunityDetail(questionId));

export interface PostQnaLikesParam {
  targetId: string;
  kind: 'QUESTION' | 'ANSWER';
}

export const postQnaLikes = async (param: PostQnaLikesParam) => {
  const res = await request<string>({
    method: 'post',
    url: '/consumer/qna/likes',
    data: param
  });
  return res;
};

export const usePostQnaLikesMutaiton = () => {
  const mutation = useMutation(postQnaLikes);
  return mutation;
};
